// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Kueo-","item":"styles_item__SUUsp","last":"styles_last__OR37y","bold":"styles_bold__+wat7","value":"styles_value__qF8jg"};